// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { PreferenceResponse } from './preference-response';

/** See com.rev360.pms.api.controller.admin.practicepreferences.SystemPreferencesResponse */
/* istanbul ignore next */
@GandalfModel
export class SystemPreferencesResponse extends GandalfModelBase {

	@GandalfArray(PreferenceResponse)
	additionalPreferences!: PreferenceResponse[] | null;

	@GandalfProperty({ designType: Number })
	autoLockPeriod!: number | null;

	@GandalfProperty({ designType: Number })
	expirationDays!: number | null;

	@GandalfProperty({ designType: Number })
	minDigits!: number | null;

	@GandalfProperty({ designType: Number })
	minLength!: number | null;

	@GandalfProperty({ designType: Number })
	minLowerCase!: number | null;

	@GandalfProperty({ designType: Number })
	minSpecialChars!: number | null;

	@GandalfProperty({ designType: Number })
	minUpperCase!: number | null;

	@GandalfProperty({ designType: Number })
	numPasswordChanges!: number | null;

	@GandalfProperty({ designType: Boolean })
	passwordExpires!: boolean | null;

}
